module.exports = __webpack_public_path__ + "img/app-store-en.2928664.svg";